import { extendCoreVideo } from './extend-core/video-front';
export function extendCoreBlocks() {
    extendCoreVideo();
}
export function initACBlocks() {
    var root = document.querySelector('.ac-blocks');
    if (!root) {
        return;
    }
    window.lightGallery && initLightGallery();
    function initLightGallery() {
        var filters = [
            function (img) { return !img.parentElement.classList.contains('-person'); },
        ];
        [].slice.apply(root.querySelectorAll('figure > img, .gallery-icon img')).forEach(function (img) {
            var parent = img.parentElement;
            parent.setAttribute('data-src', img.dataset.src || img.src);
            if (filters.every(function (filter) { return filter(img); })) {
                parent.classList.add('lg--enable');
            }
            if (parent.nodeName === 'A' && !parent.href.match(/\.(jpe?g|png|gif|webp)/)) {
                parent.setAttribute('href', img.dataset.src || img.src);
            }
            var figcaption = parent.querySelector('figcaption');
            if (figcaption) {
                parent.setAttribute('data-sub-html', figcaption.innerHTML);
            }
            else if (img.alt) {
                parent.setAttribute('data-sub-html', img.alt);
            }
        });
        var selectors = ['.lg--enable', '.blocks-gallery-item > figure', 'figure.wp-block-image'];
        selectors.forEach(function (s) { return [].slice.apply(document.body.querySelectorAll(s))
            .forEach(function (el) { return el.style.cursor = 'pointer'; }); });
        window.lightGallery(root, {
            selector: selectors,
        });
    }
}
